
import moment from 'moment';
import { Toast } from 'vant';
/**
 * 从出生日期字符串计算「x岁x个月」
 * @param {string} birthDateStr - 出生日期，格式 yyyy-mm-dd
 * @returns {string} 如 "3岁1个月" / "11个月" / "0个月" / "日期格式错误"
 */
export const getAgeYearsMonths=(birthDateStr) =>{
  if(!birthDateStr){
    return ''
  }
  // 1. 校验日期格式（yyyy-mm-dd）
  if (!birthDateStr || !/^\d{4}-\d{2}-\d{2}$/.test(birthDateStr)) {
    return "日期格式错误，请传入 yyyy-mm-dd 格式";
  }

  // 2. 解析出生日期（按本地时间，避免时区偏差）
  const [birthYear, birthMonth, birthDay] = birthDateStr.split("-").map(Number);
  const birthDate = new Date(birthYear, birthMonth - 1, birthDay); // 月份0-11
  if (isNaN(birthDate.getTime())) {
    return "无效的出生日期（如2022-13-32）";
  }

  // 3. 获取当前日期（本地时间）
  const now = new Date();
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth() + 1; // 转1-12
  const nowDay = now.getDate();

  // 4. 计算总月差（核心：先算总月数，再根据日期调整）
  let totalMonths = (nowYear - birthYear) * 12 + (nowMonth - birthMonth);
  // 如果当前日期 < 出生日期的日期 → 总月数减1（未到整月）
  if (nowDay < birthDay) {
    totalMonths--;
  }

  // 5. 处理未来日期（总月差为负）
  if (totalMonths < 0) {
    return "0个月";
  }

  // 6. 拆解为「年+月」
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  // 7. 格式化输出（适配不同场景）
  if (years > 0) {
    return `${years}岁${months}个月`;
  } else {
    return `${months}个月`; // 不足1岁只显示月数
  }
}

export const  utcToLocalTime=(utcTimeStr,timeType='YYYY-MM-DD HH:mm:ss')=> {
  // 1. 解析UTC时间 → 2. 转东八区 → 3. 格式化
  return moment.utc(utcTimeStr) // 解析为UTC时间
    .utcOffset(8) // 切换到东八区（+8小时）
    .format(timeType); // 目标格式
}

export const localTimeToUtc = (localTimeStr) => {
  // 1. 解析为东八区时间 → 2. 转UTC零时区 → 3. 格式化为带T/Z的ISO格式
  return moment(localTimeStr)       // 解析本地时间（默认按东八区识别）
    .utcOffset(8)                   // 明确当前时间是东八区（+8）
    .utc()                          // 转换为UTC零时区（自动减8小时）
    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // 目标格式（带T、毫秒、Z）
};
export const copyText=(link)=>{
  if (!link) {
    return
  }

  // 复制逻辑
  const input = document.createElement('input')
  input.value = link
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)

      Toast('复制成功');
}